<template>
  <v-app data-testid="elem_u_000001">
    <MaintenanceBanner />
    <Notification />
    <ContentCopyManuallyDialog />
    <component :is="this.$route.meta.layout">
      <router-view :key="$route.fullPath"></router-view>
    </component>
    <AcceptCookiesPopup v-if="!this.$store.state.cookiesAccepted.status"/>
  </v-app>
</template>

<script>
import AppLayout from './layouts/AppLayout';
import AuthLayout from './layouts/AuthLayout';
import ContentCopyManuallyDialog from './components/common/ContentCopyManuallyDialog';
import HomeLayout from './layouts/HomeLayout';
import MaintenanceBanner from './components/global/MaintenanceBanner.vue';
import TermsAndPrivacyLayout from './layouts/TermsAndPrivacyLayout';
import AcceptCookiesPopup from "@/components/global/AcceptCookiesPopup";

export default {
  name: 'App',

  components: {
    AcceptCookiesPopup,
    AppLayout,
    AuthLayout,
    ContentCopyManuallyDialog,
    HomeLayout,
    MaintenanceBanner,
    TermsAndPrivacyLayout,
    Notification: () => import('./components/global/Notification.vue'),
  },

  created() {
    this.$store.commit('cookiesAccepted/retrieveStatus');
  },
};
</script>
